import { default as OrderPaymentStatusPage } from './order-payment-status';
import { default as PurchaseList } from '../order/purchase-list';
import { default as OrderDetails } from '../order/order-details';
import { default as VoucherListPage } from './telemed-voucher-list';

export default {
  PurchaseList,
  OrderPaymentStatusPage,
  OrderDetails,
  VoucherListPage,
}
